
import { DeviceMonitoringFilterActions, DeviceMonitoringFilterActionTypes } from '../actions/device-monitoring-filter.actions';

export interface State {
  regionId: number;
  device_status: number;
}

export const initialState: State = {
  regionId: -1,
  device_status: -1
};

export function reducer(state = initialState, action: DeviceMonitoringFilterActions): State {
  switch (action.type) {

    case DeviceMonitoringFilterActionTypes.LoadDeviceMonitoringFilters:
      return state;

    case DeviceMonitoringFilterActionTypes.SelectDeviceMonitoringFilters:
      return {...state, regionId: action.payload.regionId, device_status: action.payload.device_status};

    default:
      return state;
  }
}
